import axios from "axios";
import commons from "./index";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  data: {
    step: 1,

    selectedShippingOptionIndex: -1,

    origin_direction: {
      full_name: "",
      email: "",
      phone: "",
      address: "",
      reference_of_origin: "",
      colony: "",
      postal_code: "",
      state_short: "",
      city: "",
      country_code: "MX",
    },

    destination_direction: {
      full_name: "",
      email: "",
      phone: "",
      address: "",
      reference_of_origin: "",
      colony: "",
      postal_code: "",
      state_short: "",
      city: "",
      country_code: "MX",
    },

    description_of_the_content: "",
    package_insurance: false,

    insurance_information: {
      package_value: null,
      responsible_for_the_package: null,
      mail_responsible: null,
      cost: null,
    },

    parcels: [
      {
        depth: "",
        width: "",
        height: "",
        weight: "",
      },
    ],

    requestBody: {
      origin_direction: {
        country_code: "",
        postal_code: "",
        city: "",
        suburb: "",
      },

      parcels: [
        {
          weight: "",
          height: "",
          depth: "",
          width: "",
        },
      ],
      destination_direction: {
        country_code: "",
        postal_code: "",
        city: "",
        suburb: "",
      },
      insured_value: "",
      insured_value_currency: "MXN",
    },
  },
  methods: {
    addParcel() {
      this.parcels.push({
        depth: "",
        width: "",
        height: "",
        weight: "",
      });
    },
    removeParcel(index) {
      if (this.parcels.length > 1) {
        this.parcels.splice(index, 1);
        console.log(this.parcels);
      }
    },
    nextStep() {
      if (this.currentStep < 6) {
        this.step++;
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.step--;
      }
    },

    calculateQuote() {
      console.log("calculateQuote");

      this.requestBody.parcels = this.parcels;

      this.requestBody.origin_direction = {
        country_code: this.origin_direction.country_code,
        postal_code: this.origin_direction.postal_code,
        city: this.origin_direction.city,
        suburb: this.origin_direction.colony,
      };

      this.requestBody.destination_direction = {
        country_code: this.destination_direction.country_code,
        postal_code: this.destination_direction.postal_code,
        city: this.destination_direction.city,
        suburb: this.destination_direction.colony,
      };

      if (this.package_insurance) {
        this.insured_value = this.insurance_information.cost;
      } else {
        delete this.insured_value;
      }

      this.setQuotingRequestBody(this.requestBody);

      this.quoting()
        .then(() => {
          this.nextStep();
        })
        .catch((error) => console.log(error));
    },

    createShipment() {
      this.setSelectedShippingOption(
        this.shippingOptions[this.selectedShippingOptionIndex]
      );

      const requestBody = {
        selected_service: {
          full_name: this.selectedShippingOption.product_short_name,
          mount: this.selectedShippingOption.shipping_charge,
          logo_url: this.selectedShippingOption.logo_url,
          delivery_time: this.selectedShippingOption.delivery_date,
          pickup_date: this.selectedShippingOption.pickup_date,
          currency_code: this.selectedShippingOption.currency_code,
        },
        shipment_type: this.quotingRequestBody.shipment_type,
        parcels: this.quotingRequestBody.parcels,
        origin_direction: this.origin_direction,
        destination_direction: this.destination_direction,
        description_of_the_content: this.description_of_the_content,
        package_insurance: this.package_insurance,
        insurance_information: this.insurance_information,
        user: localStorage.getItem("ew-user-id"),
      };

      this.setNewShipmentRequestBody(requestBody);
      this.newShipment().then(() => {
        this.getAllShipments();
        this.$router.push("/dashboard");
      });
    },

    checkAddressOrigin(event) {
      // console.log(event)
      const query = event.target.value;
      if (query.length >= 3) {
        this.getLocationInfo(query, "MX").then((response) => {
          console.log(response.data);
          this.origin_direction.city =
            response.data[0].parish + ", " + response.data[0].state;
        });
      }
    },
    checkAddressDestination(event) {
      // console.log(event)
      const query = event.target.value;
      if (query.length >= 3) {
        this.getLocationInfo(query, "MX").then((response) => {
          // console.log(response.data)
          this.destination_direction.city =
            response.data[0].parish + ", " + response.data[0].state;
        });
      }
    },
    getLocationInfo(zipCode, countryCode) {
      return axios.get(
        `${commons.apiURL}/api/v1/postalcode?zipCode=${zipCode}&country=${countryCode}`
      );
    },
    ...mapMutations([
      "netNewShipmentRequestBody",
      "setQuotingRequestBody",
      "setSelectedShippingOption",
      "setNewShipmentRequestBody",
    ]),
    ...mapActions(["quoting", "newShipment", "getAllShipments"]),
  },
  computed: {
    currentStep() {
      return this.step;
    },
    ...mapGetters([
      "quotingRequestBody",
      "selectedShippingOption",
      "serviceProviders",
      "shippingOptions",
    ]),
  },
};



// WEBPACK FOOTER //
// ./src/commons/service-provider.js